import { tickerItems } from '@/mocks/home';

export default function TopStrip() {
  const loop = [...tickerItems, ...tickerItems];
  return (
    <div className="border-b border-primary-900 bg-primary-950 text-background-100">
      <div className="flex h-9 w-full items-center overflow-hidden px-4 md:px-8">
        <span className="mr-3 hidden shrink-0 items-center gap-1.5 text-xs font-medium text-accent-300 sm:flex">
          <span className="relative flex h-2 w-2 items-center justify-center">
            <span className="absolute inline-flex h-2 w-2 animate-ping rounded-full bg-accent-400 opacity-75"></span>
            <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400"></span>
          </span>
          实时更新
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center gap-8">
            {loop.map((item, index) => (
              <span key={`${item.text}-${index}`} className="flex items-center gap-2 whitespace-nowrap text-xs text-background-200">
                <span className="rounded-sm bg-primary-800 px-1.5 py-0.5 text-[10px] text-primary-100">{item.type}</span>
                {item.text}
              </span>
            ))}
          </div>
        </div>
        <div className="ml-4 hidden shrink-0 items-center gap-4 text-xs text-background-300 lg:flex">
          <button type="button" className="cursor-pointer transition-colors hover:text-accent-300">加入收藏</button>
          <span className="text-primary-800">|</span>
          <button type="button" className="cursor-pointer transition-colors hover:text-accent-300">意见反馈</button>
        </div>
      </div>
    </div>
  );
}